export default __webpack_public_path__ + "static/media/violencia-digital-506x187.6e3ef487.jpg";